import React from 'react'
import PropTypes from 'prop-types'

import './SmsCommunicationConsent.css'

/*
SmsCommunicationConsent is only necessary when we do not need delivery consent
See: OO-3080
*/
export const SmsCommunicationConsent = ({ cart }) => {
  return cart && (
    !cart.deliveryProviderInfo || (
      cart.deliveryProviderInfo &&
      cart.deliveryProviderInfo.needsDeliveryCommunicationConsent === false
    )
  ) &&
    (
      <div styleName='sms-communication-consent'>
        <p>
          By providing a mobile number, you give Toast permission to contact you using
          automated text messages to provide transactional messages such as order
          status updates.
        </p>
      </div>
    )
}

SmsCommunicationConsent.propTypes = {
  cart: PropTypes.object.isRequired
}
